// First, so a sign-out reload clears storage before any store reads it.
import './signOutCleanup';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// Silence all console output in production
if (!import.meta.env.DEV) {
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.error = noop;
  console.debug = noop;
  console.info = noop;
}

// Global error handlers for non-React JS errors
window.onerror = (_message, _source, _lineno, _colno, _error) => {
  // Captured by ErrorBoundary + Sentry — suppress default browser dialog
};

window.onunhandledrejection = (_event: PromiseRejectionEvent) => {
  // Captured by Sentry — suppress default browser dialog
};

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
